import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
// import { Link } from 'react-router-dom';

const styles = (theme) => ({  
  paper: {
    position: 'absolute',
    top: '15%',
    left: '20%',
    padding: '32px',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    zIndex: '2000',
    width: '75%',
    maxWidth: 'calc(95vw)',
    maxHeight: (window.innerHeight - 100) + 'px !important',
  },
  modalBackdrop: {
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '2',
    position: 'fixed',
    willChange: 'opacity',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  
  },
  viewAuthButton:{
    color: '#FFF',
    backgroundColor: '#8AACB5',
    '&:hover': {
      backgroundColor: '#15585E',
 },     
  },
  tableHeader: {
    color: '#FFF',
    backgroundColor: '#15585E'
  },
  tableStripedRow: {
    "&:nth-child(even)": {
      backgroundColor: '#EEEDF8'
    },
  },
  closeButton: {
    marginTop: '20px',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#15585e',
      '& > span': {
        color: '#fff',
      },
    },
    '& > span': {
      color: '#15585e',
    },
  }
});

class DuplicateAuthsModal extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      columns: [
        { field: 'firstName', headerName: 'First Name' },
        { field: 'lastName', headerName: 'Last Name' },
      ],
      modalHeight: '0',
      modalWidth: '0',
      selectedAuthorizationID: undefined    
    };
  }

  componentDidMount() {
    this.setState({
      // modalHeight: this.modal.clientHeight,
      modalWidth: this.modal.clientWidth,
    });
  }

  getDate(addedOn) {
    let date = new Date(addedOn);
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear(); 
  
    return `${month}/${day}/${year}`;
  }
  

  handleCloseAuthorizationModal(){
    this.setState({authorizationID:  undefined});
  }

  handleDisplayingAuthorizationViewButton(mtAuthID, authorizationID, viewAuthButton, handleSetSelectedAuthorization, handleSetSelectedTransferee){
    if(authorizationID){
      return (
        <Button 
        className={viewAuthButton}
        onClick={() => handleSetSelectedAuthorization(authorizationID)} title="View authorization" 
        >View Auth
      </Button>
      )
    } else if (mtAuthID) {
      return (
        <Button 
        className={viewAuthButton}
        onClick={() => handleSetSelectedTransferee(mtAuthID)} title="View authorization" 
        >View Transferee
        </Button>
      )
    }
    return "Unavailable for viewing in ReloSource" + String.fromCharCode(8482);
  }

  // displayAuthorization(authorizationID, displayAuthsTable){
  //   selectedAuthorizationID = authorizationID;
  // }

  getStateCode(provinceId){
    const { provinceEnums } = this.props;
    let province = provinceEnums.filter((province) => province.id === provinceId);
    return province && province !== undefined && province !== null && Array.isArray(province) && province.length > 0 ?   province[0].title : '';
  }
  
  render() {
    const {
      classes,
      handleClose,
      auths,
      handleSetSelectedAuthorization,
      handleSetSelectedTransferee,
      clientId,
      
      linkedMtId,
      linkedTempId,
      nextFileNumber
    } = this.props;

    return (
      <div aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
        <div className={classes.modalBackdrop} aria-hidden="true" />
        <div
          className={classes.paper}
          ref={(elem) => {
            this.modal = elem;
          }}
        >
          <h2>
            <center>{`Similar${clientId !== '167' ? ' active' : ''} authorizations were found`}</center>
          </h2>

          <Paper sx={{ width: '100%' }}>
            <TableContainer sx={{ width: '100%' }} style={{ maxHeight: window.innerHeight - window.innerHeight * 0.4 }}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeader}>File #</TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      Transferee
                    </TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      Policy
                    </TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      Origin State
                    </TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      Destination State
                    </TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      Initiated
                    </TableCell>
                    <TableCell className={classes.tableHeader} align="left">
                      View
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {auths.map((row) => {
                    const rowId = row.tempFileId === 0 || 
                      row.tempFileId === null || 
                      row.tempFileId === '' ? 
                      `mt-${row.authorizationFileId}` : 
                      `tl-${row.tempFileId}`;

                    const isSelected = (row.tempFileId === 0 || row.tempFileId === null || row.tempFileId === '') ? row.authorizationFileId === linkedMtId : row.tempFileId === linkedTempId;
                    
                    return (
                      <TableRow
                        key={rowId}
                        className={classes.tableStripedRow}
                        selected={isSelected}
                        hover={false}
                      >

                        <TableCell component="th" scope="row">
                          {!(row.tempFileId === null || row.tempFileId === '' || row.tempFileId === 0)
                              ? `${row.tempFileId}${row.authorizationFileNumber ? ` (${row.authorizationFileNumber})` : ''}`
                              : `${row.authorizationFileId}${row.authorizationFileNumber ? ` (${row.authorizationFileNumber})` : ''}`
                              }
                        </TableCell>

                        <TableCell align="left">
                          {row.firstName} {row.lastName} {row.nickName && `(${row.nickName})`}
                        </TableCell>

                        <TableCell align="left">{row.policyId}</TableCell>
                        <TableCell align="left">{this.getStateCode(row.departureProvinceId)}</TableCell>
                        <TableCell align="left">{this.getStateCode(row.destinationProvinceId)}</TableCell>
                        <TableCell align="left">
                          {row.effectiveDate ? this.getDate(row.effectiveDate) : this.getDate(row.addedOn)}
                        </TableCell>

                        <TableCell align="left">
                          {this.handleDisplayingAuthorizationViewButton(
                            row.authorizationFileId,
                            row.tempFileId,
                            classes.viewAuthButton,
                            handleSetSelectedAuthorization,
                            handleSetSelectedTransferee
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

        <div
          className="row justify-space-around"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}
        >
          <div style={{ fontSize: 12, color: '#666' }}>
            {(linkedMtId || linkedTempId) && nextFileNumber
              ? `Creating a '${nextFileNumber.slice(-1).toUpperCase()}' file for ${
                  linkedMtId ? `authorization #${linkedMtId}` : `temp file #${linkedTempId}`
                }.`
              : ''}
          </div>

          <Button className={classes.closeButton} onClick={handleClose} variant="contained">
            Close
          </Button>
        </div>
        </div>
      </div>
    );
  }
}

DuplicateAuthsModal = withStyles(styles)(DuplicateAuthsModal);

export default DuplicateAuthsModal;